import React, { useState, useEffect } from "react";
import PlanRectCard from "./PlanRectCard";
import StripeCheckout from "react-stripe-checkout";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Button, ButtonPromo, Loader2 } from "../../../Components";
import {
  applyCoupen,
  stripePayment,
} from "../../../Redux/actions/commonActtion";
import { Loader } from "../../../Components";
import Navbar_render from "../../../Pages/ProjectV2/Render/Nav_render/Navbar_render";
import PaymentTypeModal from "./PaymentTypeModal";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./PaymentFrom";
import Styles from "./Render.module.css";
import { info } from "../../../assets/icons";

const cardDetails = {
  cardNumber: false,
  cardExpiry: false,
  cardCvc: false,
  zipcode: "",
  email: "",
};
const PaymentsDetails = ({
  isOpen,
  setIsOpen,
  selectedPlan,
  IsUpgradeOpen,
  currentPlanDetails,
  remainingDays,
  setRenderOpen,
  planPurchaseDate,
  expirationMessage,
  getTime,
  setIsSuccessOpen,
  paymentType,
  order_id,
  subscription_status,
}) => {
  const dispatch = useDispatch();

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  const [coupanName, setCoupanName] = useState("");
  const [coupanError, setCoupanError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isStripeOpen, setisStripeOpen] = useState(false);
  const [stripeOpen, setStripeOpen] = useState(false);
  const [isDiscount100, setIsDiscount100] = useState(false);
  const [card, setCard] = useState(cardDetails);
  const user = JSON.parse(localStorage.getItem("user"));
  const [product, setProduct] = useState({
    price: selectedPlan?.price,
    name: selectedPlan?.type,
    currency: "USD",
    plan_id: selectedPlan?._id,
    user_id: user._id,
  });

  const openNewTab = () => {
    const newTab = window.open("/paymentsuccess", "_blank");
    setTimeout(() => {
      if (newTab) {
        newTab.close();
      }
    }, 10000);
  };

  const makePayment = async (token) => {
    try {
      setLoading(true);
      const response = await dispatch(
        stripePayment(token, product, coupanName)
      );
      if (response?.data?.success) {
        if (response?.data?.newRecurring.stripe_status === "requires_action") {
          setLoading(false);
          return response?.data;
        } else {
          setLoading(false);
          toast.success("Payment succeeded");
          setIsOpen(false);
          IsUpgradeOpen(false);
          setIsSuccessOpen(true);
          getTime();
          setisStripeOpen(false);
          setCoupanName("");
          setCoupanError("");
          setStripeOpen(false);
          setCard(cardDetails);
          setRenderOpen(false);
          openNewTab();
        }
      } else if (response?.response?.data.success == false) {
        toast.error(response?.response?.data.message);
        setCoupanName("");
        setLoading(false);
        setisStripeOpen(false);
        setCoupanError("");
        setStripeOpen(false);
        setCard(cardDetails);
      }

      return response;
    } catch (error) {
      toast.error("An error occurred");
      setLoading(false);
      setisStripeOpen(false);
      setCoupanName("");
      setStripeOpen(false);
      setCard(cardDetails);
    }
  };
  const handleDiscount = async () => {
    if (coupanName) {
      const response = await dispatch(applyCoupen(coupanName));
      if (response?.data?.success) {
        if (response?.data?.coupans?.discount === 100) {
          setIsDiscount100(true);
          setStripeOpen(false);
        } else if (response?.data?.coupans?.discount < 100) {
          setIsDiscount100(false);
        }
        // const discountedPrice = Number(coupanName?.replace(/[^0-9]/g, ''));
        const discountedPrice = response.data.coupans.discount || 0;
        const originalPrice = selectedPlan?.price;
        const percent =
          discountedPrice === 100
            ? 0
            : originalPrice - Number((discountedPrice / 100) * originalPrice);
        // const finalPrice = originalPrice - percent
        await setProduct((prev) => ({
          ...prev,
          price: Math.round(percent),
        }));
        setCoupanError("The coupon has been successfully applied.");
      }
      if (response?.response?.data?.success === false) {
        setCoupanError(
          "The coupon you entered is either invalid or has expired."
        );
        setCoupanName("");
        setProduct((prev) => ({
          ...prev,
          price: selectedPlan?.price,
        }));
      }
    }
  };
  const stripeClosed = () => {
    setStripeOpen(false);
    setProduct((prev) => ({
      ...prev,
      price: selectedPlan?.price,
    }));
    setCoupanError("");
    setCoupanName("");
  };
  const handleMakePaymentClick = () => {
    if (paymentType === 2 && subscription_status === 1) {
      toast.error(
        "you have already subscribed please cancel subscription first."
      );
      return;
    } else if (isDiscount100) {
      makePayment({});
    } else {
      setisStripeOpen(true);
    }
  };
  const stripe = (
    <StripeCheckout
      token={makePayment}
      stripeKey={process.env.REACT_APP_STRIPE_KEY}
      name={product?.name}
      email={user?.email}
      currency="USD"
      description="Payment Description"
      amount={product?.price * 100 === 0 ? 0 : product?.price * 100}
      shippingAddress
      billingAddress
      closed={stripeClosed}
      triggerEvent="onClick"
    >
      <Button type="button" buttonStyle="btn--solid" buttonSize="btn--size">
        Pay with card
      </Button>
    </StripeCheckout>
  );
  const handleChange = (event) => {
    setCoupanName(event.target.value);
    setCoupanError("");
    setIsDiscount100(false);
    setProduct((prev) => ({
      ...prev,
      price: selectedPlan?.price,
    }));
  };

  return (
    <>
      <div className="w-full h-full">
        {loading ? <Loader2 label={"Payment Proccessing..."} /> : null}
        {isOpen === true && (
          <div className={`paymentContainer`}>
            <div
              className="payment-overlay"
              onClick={() => setIsOpen(false)}
            ></div>
            <div className="payment-content">
              <div className="projectHead">
                <Navbar_render closeModal={() => setIsOpen(false)} />
              </div>

              <div
                className={Styles.orderSumContain}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  height: "94%",
                  backgroundImage: "var(--shadeBlacklinear180)",
                }}
              >
                <div className="w-[35%] laptopsizeDiv1">
                  <div
                    className=" paymakeBlock "
                    style={{
                      borderRadius: "10px",
                      padding: "50px",
                      width: "100%",
                      marginBottom: "3.5rem"
                    }}
                  >
                    <div className="flex justify-between items-center" style={{ margin: "1rem 0" }}>
                     <div>
                     <h3
                        style={{
                          fontFamily: "Avenir book",
                          fontSize: "2rem",
                          fontWeight: "bold",
                          textDecoration: "none",
                          color: "white",
                        }}
                      >
                        Order Summary
                      </h3>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontFamily: "Avenir book",
                          fontSize: "1rem",
                          fontWeight: "500",
                          lineHeight: "1.5",
                          textDecoration: "none",
                          color: "white",
                        }}
                      >
                        Order Reference: {selectedPlan?._id}
                      </p>
                     </div>
                     <div>
                     {/* <img src={info} alt="" style={{cursor:'pointer'}} onClick={()=>window.open(`/help/670e655049a4f8d9d08f37f5`)}/> */}
                     </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontFamily: "Avenir book",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        textDecoration: "none",
                        color: "white",
                        margin: "0 auto",
                      }}
                    >
                      <div>
                        <p>{selectedPlan?.type}</p>
                        <p className="font-medium text-base">
                          renews in {selectedPlan?.validity} days until
                          cancelled
                        </p>
                      </div>
                      <div>{selectedPlan?.currency + selectedPlan?.price}</div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontFamily: "Avenir book",
                        fontSize: "1rem",
                        fontWeight: "500",
                        textDecoration: "none",
                        color: "white",
                      }}
                    >
                      <div>
                        <p style={{ marginTop: "1rem" }}>Taxes</p>
                      </div>
                      <div style={{ marginTop: "1rem" }}>calculating</div>
                    </div>

                    {(selectedPlan?.price === 99 ||
                      selectedPlan?.price === 2) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontFamily: "Avenir book",
                          fontSize: "1.1rem",
                          fontWeight: "500",
                          textDecoration: "none",
                          color: "white",
                          paddingTop: "1rem",
                        }}
                      >
                        <div>
                          <label>
                            <input
                              type="text"
                              className="w-full  p-1 user_input"
                              placeholder="Have a promo code"
                              onChange={(e) => handleChange(e)}
                              value={coupanName}
                            />
                          </label>
                        </div>
                        <div>
                          <div className="Check">
                            <ButtonPromo
                              disabled={!coupanName}
                              onClick={handleDiscount}
                            >
                              Apply
                            </ButtonPromo>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        width: "100%",
                        height: "1rem",
                        marginTop: "0.25rem",
                      }}
                    >
                      {
                        <div
                          style={{
                            color: "#fff",
                          }}
                        >
                          {coupanError}
                        </div>
                      }
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontFamily: "Avenir book",
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        textDecoration: "none",
                        color: "white",
                        marginTop: "1.5rem",
                      }}
                    >
                      <div>
                        <p>Total</p>
                      </div>
                      <div> {selectedPlan?.currency + product?.price}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        fontFamily: "Avenir book",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                        textDecoration: "none",
                        color: "white",
                        marginTop: "1.5rem",
                      }}
                    >
                      {/* do not uncomment work in progress */}
                      {/* {stripe} */}
                      <Elements stripe={stripePromise}>
                        <CheckoutForm
                          isStripeOpen={isStripeOpen}
                          setisStripeOpen={setisStripeOpen}
                          cardDetails={cardDetails}
                          card={card}
                          setCard={setCard}
                          setLoading={setLoading}
                          makePayment={makePayment}
                          setIsSuccessOpen={setIsSuccessOpen}
                          setIsOpen={setIsOpen}
                          IsUpgradeOpen={IsUpgradeOpen}
                          getTime={getTime}
                          setCoupanName={setCoupanName}
                          setCoupanError={setCoupanError}
                          openNewTab={openNewTab}
                          setRenderOpen={setRenderOpen}
                        />
                      </Elements>

                      {!isStripeOpen && (
                        <Button
                          type="button"
                          buttonStyle="btn--solid"
                          buttonSize="btn--size"
                          onClick={handleMakePaymentClick}
                        >
                          Make Payment
                        </Button>
                      )}

                      {/* {!stripeOpen && !isDiscount100 && <Button
                        type="button"
                        buttonStyle="btn--solid"
                        buttonSize="btn--size"
                        onClick={handleMakePaymentClick}
                      >
                        Next
                      </Button>} */}
                      {/* {!isDiscount100 && stripe } */}
                      {/* {!isDiscount100 && (stripeOpen && stripe)}
                      {
                        isDiscount100 &&
                        <Button
                          type="button"
                          buttonStyle="btn--solid"
                          buttonSize="btn--size"
                          onClick={() => (paymentType === 2 && subscription_status === 1) ? toast.error('you have already subscribed please cancel subscription first.') : makePayment({})}

                        >
                          {` Make Payment $${product?.price}`}

                        </Button>
                      } */}
                    </div>
                  </div>
                </div>

                <div
                  className="mt-[-3%]"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    width: "43%",
                  }}
                >
                  <div>
                    <PlanRectCard
                      lable={"SELECTED PLAN"}
                      currentPlan={selectedPlan?.type}
                      rendersLimit={selectedPlan?.text1}
                      projectLimits={selectedPlan?.text2}
                      support={" Support " + selectedPlan?.text4}
                      validity={"validity " + selectedPlan?.validity}
                      buttonLable={"Upgrade"}
                      onClick={() => setIsOpen(false)}
                    />
                  </div>

                  <div style={{ marginTop: "1rem" }}>
                    <PlanRectCard
                      lable={"CURRENT PLAN"}
                      currentPlan={
                        currentPlanDetails?._id
                          ? currentPlanDetails?.type
                          : "Free"
                      }
                      rendersLimit={
                        currentPlanDetails?._id
                          ? currentPlanDetails?.text1
                          : "Unlimited Renders"
                      }
                      projectLimits={
                        currentPlanDetails?._id ? currentPlanDetails?.text2 : ""
                      }
                      support={
                        currentPlanDetails?._id
                          ? "Support " + currentPlanDetails?.text4
                          : "Only Support 720p"
                      }
                      validity={
                        currentPlanDetails?._id
                          ? "validity " + currentPlanDetails?.validity
                          : ""
                      }
                      planRenueDate={expirationMessage}
                      planPurchaseDate={planPurchaseDate}
                      paymentType={paymentType}
                      order_id={order_id}
                      subscription_status={subscription_status}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PaymentsDetails;
